import { useEffect } from "react";
import { isEmpty } from "lodash";

import { findObjectWithProperty } from "helpers";

type UpdateCollectionSubmitProps = {
	setCollectionSubmits?: Function;
	fieldName: string;
	isDirty: boolean;
	errors: any;
	handleUpdate: Function;
	setValue: Function;
};

function useUpdateCollectionSubmit({
	setCollectionSubmits,
	fieldName,
	isDirty,
	errors,
	setValue,
	handleUpdate,
}: UpdateCollectionSubmitProps) {
	useEffect(() => {
		setCollectionSubmits?.(prev => ({
			...prev,
			[fieldName]: {
				isDirty,
				errors: findObjectWithProperty(errors, "ref")?.ref || undefined,
				handleSubmit: handleUpdate,
				setValue,
			},
		}));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isDirty, isEmpty(errors)]);
}

export default useUpdateCollectionSubmit;
